const Portfolio_data = [
  {
    id: 7,
    category: "website",
    totalLike: "690",
    title: "E-Commerce",
    image: "./image/portfolio-07.png",
    gitHub: "https://github.com/islam-khalil0/E-Commerce/tree/master",
    liveSite: "https://shoppingcartx.netlify.app/",
  },
  {
    id: 8,
    category: "website",
    totalLike: "690",
    title: "Programming company website",
    image: "./image/portfolio-08.png",
    gitHub: "https://github.com/islam-khalil0/Programming-company/tree/master",
    liveSite: "https://programmingcompanyz.netlify.app/",
  },
  {
    id: 9,
    category: "website",
    totalLike: "640",
    title: "online store for selling photos",
    image: "./image/portfolio-10.png",
    gitHub: "https://github.com/islam-khalil0/photo-shop/tree/master",
    liveSite: "https://photoshop-woad.vercel.app/",
  },
  {
    id: 2,
    category: "Website",
    totalLike: "750",
    title: "Mobile application website",
    image: "./image/portfolio-02.jpg",
    gitHub: "https://github.com/islam-khalil0/mobile-app-website",
    liveSite: "https://mobile-app0.netlify.app/",
  },
  {
    id: 10,
    category: "website",
    totalLike: "670",
    title: "Countries definition website",
    image: "./image/portfolio-09.png",
    gitHub: "https://github.com/islam-khalil0/Countries-App/tree/master",
    liveSite: "https://countriesproject70.netlify.app/",
  },
  {
    id: 1,
    category: "Website",
    totalLike: "600",
    title: "Website for an architectural firm",
    image: "./image/portfolio-01.jpg",
    gitHub: "https://github.com/islam-khalil0/website_architectural",
    liveSite: "https://islam-khalil0.github.io/website_architectural/",
  },
  {
    id: 6,
    category: "Website",
    totalLike: "690",
    title: "CRUDS Project",
    image: "./image/portfolio-06.jpg",
    gitHub: "https://github.com/islam-khalil0/cruds-project-",
    liveSite: "https://islam-khalil0.github.io/cruds-project-/",
  },
  {
    id: 3,
    category: "Website",
    totalLike: "630",
    title: "photo editor website",
    image: "./image/portfolio-03.jpg",
    gitHub: "https://github.com/islam-khalil0/photo-editor",
    liveSite: "https://islam-khalil0.github.io/photo-editor/",
  },
  {
    id: 4,
    category: "Website",
    totalLike: "360",
    title: "control Board",
    image: "./image/portfolio-04.jpg",
    gitHub: "https://github.com/islam-khalil0/dashboard-design-",
    liveSite: "https://islam-khalil0.github.io/dashboard-design-/",
  },
  {
    id: 5,
    category: "Website",
    totalLike: "280",
    title: "Online course website",
    image: "./image/portfolio-05.jpg",
    gitHub: "https://github.com/islam-khalil0/courses-website",
    liveSite: "https://islam-khalil0.github.io/courses-website/",
  },
];

export default Portfolio_data;
